import { Typography, makeStyles, Button } from "@material-ui/core";
import { Steps, useAppState } from "../../state";

const useStyles = makeStyles(theme => ({
  customerBgContainer: {
    margin: "0 auto 1em",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "contain",
    width: "300px",
    height: "20vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "top",
      backgroundSize: "cover",
      width: "100%"
    }
  }
}));

export default function PickOrderView() {
  const { setCurrentStep, findQuery, coverURL } = useAppState();
  const goClientHome = () => setCurrentStep(Steps.landingAccountPage);
  const classes = useStyles();

  return (
    <div className="centrado">
      <div
        className={classes.customerBgContainer}
        style={{ backgroundImage: `url(${coverURL})` }}
      ></div>
      <br />
      <br />
      <br />
      <Typography align="center" variant="subtitle1">
        Click here to see the status of:{" "}
      </Typography>

      <Typography align="center" variant="h6">
        <a href="#orderId"> Your order # {findQuery}</a>
      </Typography>
      <br />
      <br />
      <br />
      <Button onClick={goClientHome} color="primary" variant="contained">
        {" "}
        New Help Request{" "}
      </Button>
    </div>
  );
}
